/**
 * Get the count of reviews for a given star rating from the review breakdown.
 * Keys follow the format: "1_star", "2_star", etc.
 */
export function getRatingCount(
  rating: number,
  reviewBreakdown?: Record<string, number> | null
): number {
  return reviewBreakdown?.[`${rating}_star`] ?? 0
}

/**
 * Returns true if a rating filter button should be disabled (no reviews for that rating).
 * Only disabled when reviewBreakdown is provided and the count is 0.
 */
export function isRatingDisabled(
  rating: number,
  reviewBreakdown?: Record<string, number> | null
): boolean {
  return (
    reviewBreakdown != null && getRatingCount(rating, reviewBreakdown) === 0
  )
}
